export default __webpack_public_path__ + "static/media/apex-graphics-mobile.5ff2b7bd.jpg";